var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"top-white-box"}),_c('div',{staticClass:"top-gray-box"},[_c('h1',[_vm._v(_vm._s(_vm.settings.blogTitle))])]),_c('GiveawayBox'),_c('Articles')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }